import moment from 'moment-timezone';

export class ViewEnterprise {
	public id: number;
	public name: string;
	public createdAt: Date;
	public updatedAt: Date;
	public targetEnergyPortalBudgetMonth: number;
	public isActive: boolean;
	public agentIdList: string;
	public agentNameList: string;
	public agentCount: number;
	public billSubmissionMethodIdList: string;
	public billSubmissionMethodNameList: string;
	public contractCount: number;
	public createdBy: string;

	constructor(viewEnterprise?: Subset<ViewEnterprise>) {
		Object.assign(this, viewEnterprise);

		this.createdAt = this.createdAt ? new Date(moment(this.createdAt).format('MMM DD, YYYY hh:mm:ss a')) : this.createdAt;
		this.updatedAt = this.updatedAt ? new Date(moment(this.updatedAt).format('MMM DD, YYYY hh:mm:ss a')) : this.updatedAt;
	}

	public get agentNames(): string[] {
		return this.agentNameList ? this.agentNameList.split(', ') : [];
	}

	// The grid shows at most two agents before collapsing the rest behind an ellipsis.
	public get agentNamesSummary(): string {
		const names = this.agentNames;
		return names.length > 2 ? `${names.slice(0, 2).join(', ')}, ...` : names.join(', ');
	}

	// The budget cycle only tracks a month today, so the recurring date renders as the 1st of that month.
	public get budgetGenerationDate(): string {
		return this.targetEnergyPortalBudgetMonth
			? `${moment()
					.month(this.targetEnergyPortalBudgetMonth - 1)
					.format('MMMM')}`
			: '';
	}
}
